import React from 'react';
import ButtonLink from '../../common/TrackedButtonLink';
import {PRODUCT_SELECTOR } from "../../../constants/app";
import {dataLayerPush} from "../../../utils";

const Hero = () => {
	return (
		<section className="buying-guide-hero">
			<img
				className="hero-image"
				src={ require('../../../resources/img/hero/buying-guide.jpeg') }
				alt="Safe on counter"
			/>
			<div className="col content">
				<h2 className="title">What type of safe is right for you?</h2>
				<div className="descr">
					<p>
						With more than 120 safes to choose from, it can be daunting
						to pick the safe that&rsquo;s best for you. That&rsquo;s why we&rsquo;ve broken
						it down in one, easy-to-follow guide so you can decide what
						security features, organizational tools and peril protections
						you need to protect what&rsquo;s valuable to you.
					</p>
					<a href={PRODUCT_SELECTOR.URL} target={PRODUCT_SELECTOR.TARGET} className="btn btn-primary" onClick={(e) => {
						dataLayerPush(e)
					}}>
						Find your safe
					</a>
				</div>
			</div>
		</section>
	);
};

export default Hero;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/Hero.js